import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import VeeValidate from 'vee-validate'
import dictionary from './dictionary'
import Echo from 'laravel-echo'
import browserDetect from 'vue-browser-detect-plugin'
import errorToast from './errorToast'
import counter from './counter'
import { config } from './config'

Vue.prototype.$dictionary = dictionary

Vue.use(require('vue-moment'))
Vue.use(Buefy, {
  defaultToastPosition: 'is-top-right',
  defaultToastDuration: 2000
})
Vue.use(browserDetect)
Vue.use(VeeValidate, {
  events: 'input|blur'
})

Vue.prototype.$errorToast = errorToast(Vue.prototype.$buefy.toast)

Vue.prototype.$counter = counter

Vue.config.productionTip = false

let createAxios = () => {
  Vue.prototype.$axios = axios.create({
    baseURL: `${config.baseUrl}/api/v1/`
  })
  Vue.prototype.$axios2 = axios.create({
    baseURL: `${config.baseUrl}/api/v2/`
  })
}

let createApp = () => {
  new Vue({
    store,
    router,
    render: (h) => h(App)
  }).$mount('#app')
}

const token = localStorage.getItem('user-token')

if (!Vue.prototype.$browserDetect.isIE) {
  window.io = require('socket.io-client')
}
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer' + token
  axios
    .get(`${config.baseUrl}/api/v2/profile`)
    .then((response) => {
      store.commit('AUTH_LOGIN', { token: token, role: [response.data.roles[0].name] })
      store.commit('SET_CURRENT_USER', { user: response.data })
      if (!Vue.prototype.$browserDetect.isIE) {
        window.Echo = new Echo({
          broadcaster: 'socket.io',
          host: config.echoApirl,
          encrypted: true,
          auth: {
            headers: {
              Authorization: 'Bearer ' + token
            }
          }
        })
        window.Echo.private(`App.User.${response.data.id}`).notification((notification) => {
          Vue.prototype.$toast.open({
            message: notification.messagey,
            type: 'is-info',
            position: 'is-top-right',
            duration: 2000,
            queue: false
          })
        })
      }
    })
    .catch(() => {
      store.commit('AUTH_LOGOUT')
      localStorage.removeItem('user-token')
      delete axios.defaults.headers.common['Authorization']
      router.push('/')
    })
    .finally(() => {
      createAxios()
      createApp()
    })
} else {
  createAxios()
  createApp()
}
